//export class RequisitionItemFileCabinetBlade extends MfBladeComponent {
  //protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: RequisitionItemFileCabinetGeneratedForm}];
//};

//export class RequisitionItemFileCabinetListBlade extends MfBladeComponent {
 // protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: RequisitionItemFileCabinetListPageComponent, isMenuHidden: true }];
//};

import { IDataEndPoint, IEntityEndPoints, IFieldOptions, IFormOptions, IGridOptions, IColumnOptions, IEntityOptions } from '@framework/interfaces/IEntity';
import * as app from '@framework/app';
import * as models from '@common/domain/models/RequisitionItemFileCabinetDTO';
import { IApiServiceCommand } from '@services/api/api.service';
export class RequisitionItemFileCabinetEndPoints implements IEntityEndPoints {
	list?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionItemFileCabinet"}, method: "GET" };
	get?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionItemFileCabinet/" + serviceCommand.context.entityId}, method: "GET" };
	update?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionItemFileCabinet/update/" + serviceCommand.context.entityId}, method: "POST" };
	search?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionItemFileCabinet/lazy/"}, method: "POST" };
	pagingTotalCount?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionItemFileCabinet/lazyCount/"}, method: "POST" };
	insert?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionItemFileCabinet/create"}, method: "POST" };
	delete?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionItemFileCabinet/delete/"+ serviceCommand.context.entityId}, method: "POST" };
}

export class RequisitionItemFileCabinetFormFields extends Array<IFieldOptions> {
	public id: IFieldOptions = { field: "id" };
	public status: IFieldOptions = { field: "status" };
	public datestamp: IFieldOptions = { field: "datestamp" };
	public changedById: IFieldOptions = { field: "changedById" };
	public requisitionItemId: IFieldOptions = { field: "requisitionItemId" };
	public fileCabinetId: IFieldOptions = { field: "fileCabinetId" };
	constructor() {
		super();
		this.push(this.id);
		this.push(this.status);
		this.push(this.datestamp);
		this.push(this.changedById);
		this.push(this.requisitionItemId);
		this.push(this.fileCabinetId);
	}
}

export class RequisitionItemFileCabinetForm implements IFormOptions {
	protected requisitionItemFileCabinetFormName: string = "requisitionItemFileCabinetForm";
	protected requisitionItemFileCabinetFormModel: models.RequisitionItemFileCabinetDTO = new models.RequisitionItemFileCabinetDTO();
	protected requisitionItemFileCabinetFormEndPoints: RequisitionItemFileCabinetEndPoints = new RequisitionItemFileCabinetEndPoints();
	protected requisitionItemFileCabinetFormFields: RequisitionItemFileCabinetFormFields = new RequisitionItemFileCabinetFormFields();
	public get name(): string { return this.requisitionItemFileCabinetFormName };
	public get model(): models.RequisitionItemFileCabinetDTO { return this.requisitionItemFileCabinetFormModel };
	public get endPoints(): IEntityEndPoints { return this.requisitionItemFileCabinetFormEndPoints };
       public set endPoints(requisitionItemFileCabinetEndPoints: IEntityEndPoints) {
		this.requisitionItemFileCabinetFormEndPoints = requisitionItemFileCabinetEndPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.get };
	public get fields(): RequisitionItemFileCabinetFormFields { return this.requisitionItemFileCabinetFormFields };
}

export class RequisitionItemFileCabinetListColumns extends Array<IColumnOptions> {
	public id: IColumnOptions = { field: "id" };
	public status: IColumnOptions = { field: "status" };
	public datestamp: IColumnOptions = { field: "datestamp", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public changedById: IColumnOptions = { field: "changedById" };
	public requisitionItemId: IColumnOptions = { field: "requisitionItemId" };
	public fileCabinetId: IColumnOptions = { field: "fileCabinetId" };
	constructor() {
		super();
		this.push(this.id);
		this.push(this.status);
		this.push(this.datestamp);
		this.push(this.changedById);
		this.push(this.requisitionItemId);
		this.push(this.fileCabinetId);
	}
}

export class RequisitionItemFileCabinetList implements IGridOptions {
	protected requisitionItemFileCabinetListName: string = "requisitionItemFileCabinetList";
	protected requisitionItemFileCabinetListModel: models.RequisitionItemFileCabinetDTO = new models.RequisitionItemFileCabinetDTO();
	protected requisitionItemFileCabinetListEndPoints: RequisitionItemFileCabinetEndPoints = new RequisitionItemFileCabinetEndPoints();
	protected requisitionItemFileCabinetListColumns: RequisitionItemFileCabinetListColumns = new RequisitionItemFileCabinetListColumns();
	public requisitionItemFileCabinetForm: RequisitionItemFileCabinetForm = new RequisitionItemFileCabinetForm();
	public get name(): string { return this.requisitionItemFileCabinetListName };
	public get model(): models.RequisitionItemFileCabinetDTO { return this.requisitionItemFileCabinetListModel };
	public get endPoints(): IEntityEndPoints { return this.requisitionItemFileCabinetListEndPoints };
	public set endPoints(requisitionItemFileCabinetEndPoints: IEntityEndPoints) {
		this.requisitionItemFileCabinetListEndPoints = requisitionItemFileCabinetEndPoints;
		this.requisitionItemFileCabinetForm.endPoints = this.endPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.list };
	public get columns(): RequisitionItemFileCabinetListColumns { return this.requisitionItemFileCabinetListColumns };
}

export class RequisitionItemFileCabinetEntity implements IEntityOptions {
	protected requisitionItemFileCabinetEntityName: string = "requisitionItemFileCabinetEntity";
	protected requisitionItemFileCabinetEntityModel: models.RequisitionItemFileCabinetDTO = new models.RequisitionItemFileCabinetDTO();
	protected requisitionItemFileCabinetEntityEndPoints: RequisitionItemFileCabinetEndPoints = new RequisitionItemFileCabinetEndPoints();
	protected requisitionItemFileCabinetEntityList: RequisitionItemFileCabinetList = new RequisitionItemFileCabinetList();
	public get name(): string { return this.requisitionItemFileCabinetEntityName };
	public get model(): models.RequisitionItemFileCabinetDTO { return this.requisitionItemFileCabinetEntityModel };
	public get endPoints(): IEntityEndPoints { return this.requisitionItemFileCabinetEntityEndPoints };
	public set endPoints(requisitionItemFileCabinetEndPoints: IEntityEndPoints) {
		this.requisitionItemFileCabinetEntityEndPoints = requisitionItemFileCabinetEndPoints;
		this.grid.endPoints = this.endPoints;
	};
	public get grid(): RequisitionItemFileCabinetList { return this.requisitionItemFileCabinetEntityList };
	public get form(): RequisitionItemFileCabinetForm { return this.grid.requisitionItemFileCabinetForm };
	constructor(name?: string) {
		if (name) this.requisitionItemFileCabinetEntityName = name;
		this.endPoints = this.requisitionItemFileCabinetEntityEndPoints;
	}
};
//export class RequisitionItemFileCabinetGeneratedForm extends MfGeneratedFormComponent {
 // protected detailPageComponentForm: RequisitionItemFileCabinetForm = new RequisitionItemFileCabinetForm();
//};

//export class RequisitionItemFileCabinetListPageComponent extends ListPageComponent {
  //protected listPageComponentList: RequisitionItemFileCabinetList = new  RequisitionItemFileCabinetList();
  //protected showFilterColOnTable: boolean = true;
//};

